export default {"src":"/_next/static/media/ic-sentiment-4.eadafc13.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};